import './styles/main.scss';
import van from 'vanjs-core';
import {Page1} from "./layouts/page1";
import {Page2} from "./layouts/page2";
import {Page3} from "./layouts/page3";
import {Carousel} from "bootstrap/js/dist/carousel";

const {div} = van.tags;

const CarouselEl = () => {
    return  div({id: "carousel", class: "carousel slide h-100", 'data-bs-ride': "carousel", 'data-bs-interval': "10000", 'data-bs-wrap': "true", 'data-bs-pause': "false"},
        div({class: "carousel-inner min-h-100"},

            div({class: "carousel-item active min-h-100-v",  'data-bs-interval': "10000"},
                Page3,
            ),
            div({class: "carousel-item min-h-100-v",  'data-bs-interval': "10000"},
                Page1,
            ),
            div({class: "carousel-item min-h-100-v",  'data-bs-interval': "10000"},
                Page2,
            ),

        ),
    );
};
/*
van.add(document.getElementById('root'), CarouselEl);
van.add(document.getElementById('root'), Page1);
van.add(document.getElementById('root'), Page2);
van.add(document.getElementById('root'), Page3);
*/

van.add(document.getElementById('root'), CarouselEl);